import { useState, useMemo, useCallback } from 'react';
function useStepper(count) {
    const [active, setActive] = useState(0);
    const [skipped, setSkipped] = useState([]);
    const hasPrevious = useMemo(() => {
        if (active === 0)
            return false;
        return true;
    }, [active]);
    const hasNext = useMemo(() => {
        if (active === count - 1)
            return false;
        return true;
    }, [count, active]);
    const goToPrevious = useCallback(() => {
        if (hasPrevious) {
            setSkipped(skipped.filter((value) => value !== active - 1));
            setActive(active - 1);
        }
    }, [active, hasPrevious, skipped, setSkipped]);
    const goToNext = useCallback(() => {
        if (hasNext) {
            setActive(active + 1);
        }
    }, [active, hasNext]);
    const skip = useCallback(() => {
        setSkipped([...skipped, active]);
        goToNext();
    }, [skipped, active, goToNext, setSkipped]);
    const goToStep = useCallback((stepIndex) => {
        if (stepIndex >= 0 && stepIndex < count) {
            setActive(stepIndex);
        }
    }, [count, setActive]);
    return {
        skipped,
        active,
        hasNext,
        hasPrevious,
        goToNext,
        goToPrevious,
        skip,
        goToStep,
    };
}
export default useStepper;
